import Fraction from "fraction.js";
import { useState } from "react";

export function Ingredient({ ingredient }: any) {
  const [isChecked, setChecked] = useState(false);
  const qty = String(ingredient?.quantity);

  const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setChecked(e.target.checked);
  };

  return (
    <div
      className={`flex border-b border-[#D2D0D1] py-4 items-center last:border-none gap-4`}
    >
      <input
        className="w-5 h-5 accent-black rounded-full"
        type="checkbox"
        id=""
        checked={isChecked}
        onChange={handleOnChange}
      />

      <div className="flex flex-col gap-1">
        <div className="flex items-center gap-2">
          <span className={`flex-grow ${isChecked && "line-through"}`}>
            {(() => {
              try {
                if (qty !== "0") {
                  const cleanedQuantity = qty.replace(/[A-Za-z]/g, "");
                  const IngredientQuantity = new Fraction(
                    cleanedQuantity
                  ).simplify();
                  const IngredientUnit =
                    ingredient?.unit &&
                    ingredient?.unit !== "None" &&
                    ingredient?.unit !== "Empty"
                      ? `${ingredient.unit} `
                      : "";
                  return `${IngredientQuantity.toFraction()} ${IngredientUnit} `;
                }
              } catch (error) {
                console.error("Error in quantity:", error);
              }
              return "";
            })()}
            {} {ingredient?.ingredientName}
          </span>
          <span>{ingredient?.optional === "true" && " (optional)"}</span>
        </div>
        {ingredient?.notes && (
          <div className="flex mt-1 gap-2">
            <span className="font-semibold">Notes:</span>
            <p> {ingredient?.notes}</p>
          </div>
        )}
      </div>
    </div>
  );
}
